import React from "react";
import avatar from "../assets/Avatar.png";
import './Links.css';

const Links = () => {
  return (
    <div className="container-links">
      <img src={avatar} alt="Avatar" className="avatar-links" />
      <div className="btn-group-links">
        <h1 className="btn-texto-principal">Seja bem-vindo! Somos a Comunidade Aqui tem Freela e Vaga, uma iniciativa voluntária dedicada a conectar profissionais e oportunidades. 🎈</h1>     
        <a href="https://forms.gle/s7xjZUtBjxZb59Qd9" className="btn-links Destaque">Cadastro</a>
        <a href="mailto:aquitemfreelaevaga@gmail.com" className="btn-links Destaque">Enviar Vaga/Freela</a>
        
        <a href="https://www.linkedin.com/company/aqui-tem-freela-marketing-e-tecnologia" className="btn-links Destaque">Página no LinkedIn</a>
        <a href="https://www.linkedin.com/in/beatrizreiss/" className="btn-links">LinkedIn da Beatriz</a>
        <a href="https://www.linkedin.com/in/gustavoassis-martech/" className="btn-links">LinkedIn do Gustavo</a>

      </div>
      <div className="Footer-links">
        <p className="Footer-links-p1">Aqui tem Freela e Vaga - Por Beatriz e <a href="https://user.dev.br" target="_blank" rel="noopener noreferrer">Gustavo</a></p>
        
       </div>
    </div>
  );
};

export default Links;
